import LogoClub from '../assets/images/logoclub1.png'
import Logo4 from '../assets/images/logofooter1x.png'
import LogoBay from '../assets/images/logo.bay.png'
import Social1 from '../assets/images/b1.svg'
import Social2 from '../assets/images/b2.svg'
import Social3 from '../assets/images/b3.svg'
import Social4 from '../assets/images/b4.svg'
import Social5 from '../assets/images/b5.svg'

const Footer = () => {

	return (
		<>
			<div className='section_footer'>


			<div className="logo_footer">
					<img src={Logo4} alt="logo" className="logo1"/>

					<a href="https://mandala.club/"><img src={LogoBay} alt="logo" className="logo1 logobay"/></a>


				<a href="https://mandala.club/"><img src={LogoClub} alt="logo" className="logo1"/></a>




				</div>

				<div className="sologan">
				For sponsorship enquiries and general enquiries, please contact <a href="mailto:ENQUIRIES@MANDALAMASTERS.COM">ENQUIRIES@MANDALAMASTERS.COM</a> Or <a href="https://wa.link/9b31rz" target={"_blank"}>WhatsApp</a>

{/* <a href="https://mandala.club/" target={"_blank"} className="logoclubLink"><img src={LogoClub} alt="logo" className="logoclub"/></a> */}

				</div>

				{/* <div className="social">
					<ul>

						<li>
							<a href="https://www.facebook.com/mandalaweekender" target="_black"><img src={Social2} alt="social" /></a>
						</li>

						<li>
							<a href="https://www.instagram.com/mandalaweekender/" target="_black"><img src={Social3} alt="social" /></a>
						</li>
						<li>
							<a href="#" target="_black"><img src={Social4} alt="social" /></a>
						</li>
						<li>
							<a href="#" target="_black"><img src={Social5} alt="social" /></a>
						</li>
					</ul>
				</div> */}


			</div>

		</>
	);
};

export default Footer;
